module.exports = __webpack_public_path__ + "assets/img/ability36.efb05ed7.png";